import React, { useEffect, useState } from "react";
import Table from "../../utilities/Table";
import { userColumns } from "../../utilities/utility";
import UserCards from "../components/users/UserCards";
import axios from "axios";

export default function Users() {
  const [user, setUser] = useState([]);
  useEffect(() => {
    const getUsers = async () => {
      const { data } = await axios.get("/api/users");
      setUser(data);
    }
    getUsers();
  }, []);
  return (
    <div className="wrapper wrapper-content">
      <UserCards total={user} />
      <Table title="User" flag={true} data={user} columns={userColumns} />
    </div>
  );
}
